"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitDamageReflectEffectHandler = exports.SplitDamageReflectEffectArgs = void 0;
const CustomScript_1 = require("../../event-handlers/core/CustomScript");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class SplitDamageReflectEffectArgs {
    constructor(originalCreatorId, enemies) {
        this.originalCreatorId = originalCreatorId;
        this.enemies = enemies;
        this.__type = EffectType_1.EffectType.SplitDamageReflect;
        this.__typeName = "SplitDamageReflect";
        this.name = "Group Damage Reflect";
        this.harmful = false;
    }
}
exports.SplitDamageReflectEffectArgs = SplitDamageReflectEffectArgs;
let SplitDamageReflectEffectHandler = class SplitDamageReflectEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            originalCreatorId: state.args.originalCreatorId,
            enemies: state.args.enemies
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Damaged, Schedule_1.Schedule.Unlimited, new CustomScript_1.CustomScriptEventHandlerArgs("Effect_SplitDamageReflect", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
SplitDamageReflectEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.SplitDamageReflect)
], SplitDamageReflectEffectHandler);
exports.SplitDamageReflectEffectHandler = SplitDamageReflectEffectHandler;
